import React from 'react';

const IconEyeOff = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>;
const IconClock = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const IconFile = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="9" y1="14" x2="15" y2="14" /><line x1="9" y1="18" x2="12" y2="18" /></svg>;

const CARDS = [
    { bg: '#4A67FF', Icon: IconEyeOff, t: "Sellers – PISCES transaction readiness", d: 'Automated processes to help you meet your regulatory requirements across multiple windows' },
    { bg: '#FC7785', Icon: IconClock, t: 'Buyers – automated diligence tools', d: 'We give you the AI diligence tools to increase your confidence in the seller’s information.' },
    { bg: '#6e56cf', Icon: IconFile, t: 'Operators – automated process recording', d: 'We give you automated reporting to support your compliance with regulatory requirements' },
];

const PiscesProblemSection = () => (
    <section className="lp-prob-sec">
        <div className="lp-prob-head">
            <div className="lp-eyebrow" data-lp-reveal><span className="lp-ww-eyebrow">The opportunity</span></div>
            <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ maxWidth: '1200px' }}>One integrated platform for sellers, buyers, platform operators and regulator</h2>
            <p className="lp-prob-lead" data-lp-reveal data-lp-delay="120">PISCES will work if the process is quick, inexpensive and easy for all stakeholders</p>
        </div>
        <div className="lp-prob-grid">
            {CARDS.map(({ bg, Icon, t, d }, i) => (
                <div className="lp-prob-card" key={i} style={{ background: bg }} data-lp-reveal data-lp-delay={i * 120}>
                    <div className="lp-prob-icon"><Icon /></div>
                    <h3>{t}</h3>
                    <p>{d}</p>
                </div>
            ))}
        </div>
        <p className="lp-prob-close" data-lp-reveal>Diligentsia closes all three gaps — simultaneously.</p>
    </section>
);

export default PiscesProblemSection;
